import { useCallback } from 'react';
import Particles from 'react-particles';
import type { Engine } from 'tsparticles-engine';
import { loadSlim } from 'tsparticles-slim';
import type { ISourceOptions } from 'tsparticles-engine';

// Detect if device is mobile with memoization
const useIsMobile = () => {
  const isMobile = typeof window !== 'undefined' && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  return isMobile;
};

const mobileConfig: ISourceOptions = {
  background: {
    color: {
      value: 'transparent',
    },
  },
  fpsLimit: 30,
  particles: {
    number: {
      value: 100,
      density: {
        enable: true,
        area: 1000,
      },
    },
    color: {
      value: '#ffffff',
    },
    shape: {
      type: "circle",
    },
    opacity: {
      value: 0.5,
    },
    size: {
      value: { min: 0.3, max: 1 },
    },
    move: {
      enable: true,
      speed: 1,
      direction: "none",
      random: true,
      straight: false,
      outModes: {
        default: "out"
      },
    },
  },
  detectRetina: false,
  smooth: false,
};

const desktopConfig: ISourceOptions = {
  background: {
    color: {
      value: 'transparent',
    },
  },
  fpsLimit: 60,
  particles: {
    number: {
      value: 300,
      density: {
        enable: true,
        area: 1500,
      },
    },
    color: {
      value: '#ffffff',
    },
    shape: {
      type: "circle",
    },
    opacity: {
      value: { min: 0.4, max: 0.9 },
      animation: {
        enable: true,
        speed: 0.2,
        sync: false,
        minimumValue: 0.4
      }
    },
    size: {
      value: { min: 0.3, max: 1 },
      animation: {
        enable: true,
        speed: 0.3,
        minimumValue: 0.3,
        sync: false
      }
    },
    move: {
      enable: true,
      speed: 1.2,
      direction: "none",
      random: true,
      straight: false,
      outModes: {
        default: "out"
      },
      attract: {
        enable: true,
        rotateX: 600,
        rotateY: 1200
      }
    },
  },
  interactivity: {
    detectsOn: "window",
    events: {
      onHover: {
        enable: true,
        mode: "grab"
      },
      resize: true
    },
    modes: {
      grab: {
        distance: 140,
        links: {
          opacity: 0.5,
          color: "#0066ff"
        }
      }
    }
  },
  detectRetina: true,
  smooth: true,
};

export default function Background() {
  const isMobile = useIsMobile();
  
  const particlesInit = useCallback(async (engine: Engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={isMobile ? mobileConfig : desktopConfig}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 0
      }}
    />
  );
}

